import { render, staticRenderFns } from "./StampUploadModal.vue?vue&type=template&id=700b94e9&scoped=true&"
import script from "./StampUploadModal.vue?vue&type=script&lang=ts&"
export * from "./StampUploadModal.vue?vue&type=script&lang=ts&"
import style0 from "./StampUploadModal.vue?vue&type=style&index=0&id=700b94e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b94e9",
  null
  
)

export default component.exports